mutation LeadCardFieldsUpdate($input: LeadCardFieldsUpdateInput!) {
    leadCardFieldsUpdate(input: $input) {
        fieldId
        isRequired
        isRemoveable
    }
}
